var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkylineSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 783,
    viewBox: "0 0 1170 783",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M509.5 526.5H536.5V781.5H509.5V526.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 528H511V534V600H516V534H535V528H516Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M559.5 526.5H579.5V781.5H559.5V526.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M536.5 526.5H559.5V781.5H536.5V526.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M553.5 511.5H566.5V526.5H553.5V511.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M522.5 511.5H553.5V526.5H522.5V511.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M375.5 618.5H438.5V781.5H375.5V618.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M355.5 618.5H375.5V781.5H355.5V618.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357 620H356.9V626.292H357V665H363.3V626.292H374V620H363.3H357Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M377 620H437V626H377V620Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M425.5 604.6V618.5H371.5V604.6C371.761 604.507 372.076 604.398 372.443 604.276C373.697 603.861 375.561 603.303 377.973 602.744C382.797 601.625 389.808 600.5 398.5 600.5C407.192 600.5 414.203 601.625 419.027 602.744C421.439 603.303 423.303 603.861 424.557 604.276C424.924 604.398 425.239 604.507 425.5 604.6Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M603.5 480.5H632.5V781.5H603.5V480.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M573.5 480.5H603.5V781.5H573.5V480.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581 482H575V488V525H581V488H602V482H581Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M605 482H631V488H605V482Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M477.5 621.5H529.5V601.5H477.5V621.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M436.5 571.5H488.5V781.5H436.5V571.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M445.5 571.5H454.5V561.5H445.5V571.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M454.5 571.5H463.5V561.5H454.5V571.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444 573H438V578V780H444V578H487V573H444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M109.5 454.5H164.5V781.5H109.5V454.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49986,
    d: "M95.5 422.5H144.5V439.5H95.5V422.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49986,
    d: "M117.5 412.5H153.5V439.5H117.5V412.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M68.5 454.5H108.5V781.5H68.5V454.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M110 456H117V665H110V456Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.566476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166 408H152V438H77V456H166L166 439V408Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166 408H152V438H77V456H166L166 439V408Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 408V405H149V408H152ZM166 408H169V405H166V408ZM152 438V441H155V438H152ZM77 438V435H74V438H77ZM77 456H74V459H77V456ZM166 456V459H169V456L166 456ZM166 439L169 439V439H166ZM152 411H166V405H152V411ZM155 438V408H149V438H155ZM152 435H77V441H152V435ZM74 438V456H80V438H74ZM77 459H166V453H77V459ZM169 456L169 439L163 439L163 456L169 456ZM163 408V439H169V408H163Z",
    fill: "white",
    mask: "url(#path-26-inside-1)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75765,
    d: "M309.5 446.5H346.5V781.5H309.5V446.5Z",
    fill: "#539CC9",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75765,
    d: "M257.5 446.5H309.5V781.5H257.5V446.5Z",
    fill: "#539CC9",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M259 448H271V513H259V448Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M311 448H318V654H311V448Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75765
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 413H304.652V426.149L268 430.051V448H327V443.513V423.769V413Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 413H304.652V426.149L268 430.051V448H327V443.513V423.769V413Z",
    fill: "#539CC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.652 413V410H301.652V413H304.652ZM327 413H330V410H327V413ZM304.652 426.149L304.969 429.132L307.652 428.846V426.149H304.652ZM268 430.051L267.682 427.068L265 427.354V430.051H268ZM268 448H265V451H268V448ZM327 448V451H330V448H327ZM304.652 416H327V410H304.652V416ZM307.652 426.149V413H301.652V426.149H307.652ZM304.334 423.166L267.682 427.068L268.318 433.034L304.969 429.132L304.334 423.166ZM265 430.051V448H271V430.051H265ZM268 451H327V445H268V451ZM330 448V443.513H324V448H330ZM330 443.513V423.769H324V443.513H330ZM324 413V423.769H330V413H324Z",
    fill: "white",
    mask: "url(#path-32-inside-2)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M220.5 533.5H272.5V781.5H220.5V533.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M220.5 533.5H272.5V514.5H220.5V533.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651739,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271 535H222V537.703V546.714V781H233.582V546.714H271V535Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271 516H222V516.889V518.667V532H226.455V518.667H271V516Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271 516H222V516.889V518.667V532H226.455V518.667H271V516Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 516V513.3H219.3V516H222ZM271 516H273.7V513.3H271V516ZM222 532H219.3V534.7H222V532ZM226.455 532V534.7H229.155V532H226.455ZM226.455 518.667V515.967H223.755V518.667H226.455ZM271 518.667V521.367H273.7V518.667H271ZM222 518.7H271V513.3H222V518.7ZM224.7 516.889V516H219.3V516.889H224.7ZM224.7 518.667V516.889H219.3V518.667H224.7ZM224.7 532V518.667H219.3V532H224.7ZM226.455 529.3H222V534.7H226.455V529.3ZM223.755 518.667V532H229.155V518.667H223.755ZM271 515.967H226.455V521.367H271V515.967ZM268.3 516V518.667H273.7V516H268.3Z",
    fill: "white",
    mask: "url(#path-37-inside-3)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M186.5 587.5H238.5V781.5H186.5V587.5Z",
    fill: "#9BD3D7",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.379883,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 589H188V591V594V691L193 702V594H237V589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M309.5 655.5H342.5V666.5H309.5V655.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M309.5 655.5H325.5V666.5H309.5V655.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M289.5 666.5H368.5V689.5H289.5V666.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M289.5 666.5H309.107L312.279 689.5H289.5V666.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M289.5 689.5H381.393L442.21 781.5H289.5V689.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M289.5 689.5H325.047L370.584 781.5H289.5V689.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736723,
    d: "M147.5 716.5H304.152L338.51 781.5H147.5V716.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M71.5 666.5H153.5V689.5H71.5V666.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M48.5 689.5H185.764L227.668 781.5H48.5V689.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.430618,
    d: "M46.5 689.5H78.4615L127.501 781.5H46.5V689.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M71.5 666.5H97.5V689.5H71.5V666.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1.5 647.5H58.5V781.5H1.5V647.5Z",
    fill: "#9BD3D7",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M11.5 628.5H46.5V647.5H11.5V628.5Z",
    fill: "#9BD3D7",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M70 456H77V666H70V456Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M477.5 621.5H529.5V781.5H477.5V621.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528 603H478V603.895V605.684V620H482.545V605.684H528V603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M863.5 549.5V538.5H889.5V549V549.803L890.168 550.248L901.5 557.803V571.242V781.5H824.5V572.5H850H851.5V571V556.893L862.714 550.819L863.5 550.393V549.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M866.5 541.5H886.5V543.002H866.5V541.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865 555V551.29L856.007 556.153L853 557.77V557.78V562V574H831H826V579V713H831V579H853H857V574V559.667L865 555Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865 555V551.29L856.007 556.153L853 557.77V557.78V562V574H831H826V579V713H831V579H853H857V574V559.667L865 555Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 551.29H868V546.257L863.573 548.651L865 551.29ZM865 555L866.512 557.591L868 556.723V555H865ZM856.007 556.153L857.428 558.796L857.435 558.792L856.007 556.153ZM853 557.77L851.58 555.128L850 555.977V557.77H853ZM853 574V577H856V574H853ZM826 574V571H823V574H826ZM826 713H823V716H826V713ZM831 713V716H834V713H831ZM831 579V576H828V579H831ZM857 579V582H860V579H857ZM857 559.667L855.488 557.075L854 557.944V559.667H857ZM862 551.29V555H868V551.29H862ZM857.435 558.792L866.427 553.929L863.573 548.651L854.58 553.515L857.435 558.792ZM854.42 560.412L857.428 558.796L854.587 553.511L851.58 555.128L854.42 560.412ZM856 557.78V557.77H850V557.78H856ZM856 562V557.78H850V562H856ZM856 574V562H850V574H856ZM831 577H853V571H831V577ZM826 577H831V571H826V577ZM829 579V574H823V579H829ZM829 713V579H823V713H829ZM831 710H826V716H831V710ZM828 579V713H834V579H828ZM853 576H831V582H853V576ZM857 576H853V582H857V576ZM854 574V579H860V574H854ZM854 559.667V574H860V559.667H854ZM863.488 552.409L855.488 557.075L858.512 562.258L866.512 557.591L863.488 552.409Z",
    fill: "white",
    mask: "url(#path-59-inside-4)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M953.5 588.5H973.5V781.5H953.5V588.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M973.5 588.5H1021.5V781.5H973.5V588.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M897.5 649.5H1002.5V781.5H897.5V649.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972 590H961H955V596V647.998H961V596H972V590Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-65-inside-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020 590H980H975V594.502V648H980V594.502H1020V590Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020 590H980H975V594.502V648H980V594.502H1020V590Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 590V587H1023V590H1020ZM975 590H972V587H975V590ZM975 648V651H972V648H975ZM980 648H983V651H980V648ZM980 594.502H977V591.502H980V594.502ZM1020 594.502H1023V597.502H1020V594.502ZM980 587H1020V593H980V587ZM975 587H980V593H975V587ZM972 594.502V590H978V594.502H972ZM972 648V594.502H978V648H972ZM980 651H975V645H980V651ZM983 594.502V648H977V594.502H983ZM1020 597.502H980V591.502H1020V597.502ZM1023 590V594.502H1017V590H1023Z",
    fill: "white",
    mask: "url(#path-65-inside-5)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1002.5 649.5H1041.5V781.5H1002.5V649.5Z",
    fill: "#F6AA58",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    d: "M1004 651H1040V657H1004V651Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001 713V657V651H995H899V657H995V713H1001Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.520229,
    d: "M686.936 233.548L688.681 137.5H703.728L705.472 233.548H686.936Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M694.688 228.012H707.881V244.822H694.688V228.012Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M686.401 244.822L684.11 228.012H694.387V244.822H686.401Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.480073,
    d: "M715.079 252.071C715.079 259.142 714.499 263.77 713.526 266.764C712.57 269.705 711.299 270.891 709.969 271.414C708.502 271.99 706.635 271.907 704.144 271.567C703.651 271.5 703.136 271.423 702.602 271.343C700.565 271.038 698.257 270.693 695.887 270.693C693.516 270.693 691.208 271.038 689.172 271.343C688.638 271.423 688.122 271.5 687.63 271.567C685.138 271.907 683.272 271.99 681.804 271.414C680.474 270.891 679.204 269.705 678.247 266.764C677.274 263.77 676.695 259.142 676.695 252.071C676.695 249.348 678.509 246.746 682.001 244.745C685.473 242.755 690.376 241.519 695.887 241.519C701.398 241.519 706.301 242.755 709.772 244.745C713.264 246.746 715.079 249.348 715.079 252.071Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.480073,
    d: "M724.075 267.482C724.075 271.297 721.302 275.059 716.145 277.953C711.036 280.82 703.877 282.64 695.887 282.64C687.897 282.64 680.737 280.82 675.628 277.953C670.471 275.059 667.698 271.297 667.698 267.482C667.698 263.666 670.471 259.905 675.628 257.011C680.737 254.144 687.897 252.324 695.887 252.324C703.877 252.324 711.036 254.144 716.145 257.011C721.302 259.905 724.075 263.666 724.075 267.482Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.480073,
    d: "M727.674 274.585C727.674 281.263 726.744 285.346 725.27 287.813C723.872 290.154 721.896 291.183 719.237 291.518C716.461 291.868 713.083 291.442 709.053 290.874C708.833 290.843 708.611 290.812 708.387 290.78C704.596 290.244 700.345 289.644 695.887 289.644C691.428 289.644 687.178 290.244 683.386 290.78C683.163 290.812 682.941 290.843 682.721 290.874C678.69 291.442 675.313 291.868 672.537 291.518C669.877 291.183 667.902 290.154 666.503 287.813C665.03 285.346 664.1 281.263 664.1 274.585C664.1 270.891 667.15 267.139 673.017 264.22C678.793 261.347 686.876 259.527 695.887 259.527C704.897 259.527 712.981 261.347 718.756 264.22C724.623 267.139 727.674 270.891 727.674 274.585Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M736.538 781.482C735.308 779.444 733.697 775.886 731.863 769.629C728.055 756.639 723.209 731.751 718.932 684.018C714.654 636.267 710.942 537.858 708.3 451.436C706.978 408.214 705.924 367.974 705.2 338.54C704.838 323.823 704.559 311.807 704.37 303.47C704.275 299.302 704.203 296.053 704.155 293.846C704.139 293.087 704.125 292.451 704.114 291.943H695.387V781.482H736.538Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M654.236 781.482C655.465 779.444 657.076 775.886 658.91 769.629C662.719 756.639 667.565 731.751 671.841 684.018C676.119 636.269 680.056 537.863 682.923 451.44C684.357 408.218 685.524 367.979 686.332 338.544C686.736 323.827 687.051 311.811 687.264 303.474C687.371 299.306 687.453 296.057 687.507 293.851C687.526 293.089 687.542 292.451 687.555 291.943H695.387V781.482H654.236Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.480073,
    d: "M727.674 288.192C727.674 291.918 724.617 295.695 718.753 298.63C712.978 301.519 704.896 303.35 695.887 303.35C686.877 303.35 678.795 301.519 673.021 298.63C667.157 295.695 664.1 291.918 664.1 288.192C664.1 284.466 667.157 280.689 673.021 277.754C678.795 274.865 686.877 273.034 695.887 273.034C704.896 273.034 712.978 274.865 718.753 277.754C724.617 280.689 727.674 284.466 727.674 288.192Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.480073,
    d: "M727.674 294.495C727.674 298.221 724.617 301.998 718.753 304.933C712.978 307.822 704.896 309.653 695.887 309.653C686.877 309.653 678.795 307.822 673.021 304.933C667.157 301.998 664.1 298.221 664.1 294.495C664.1 290.769 667.157 286.992 673.021 284.057C678.795 281.168 686.877 279.337 695.887 279.337C704.896 279.337 712.978 281.168 718.753 284.057C724.617 286.992 727.674 290.769 727.674 294.495Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.520229,
    d: "M690.538 125.767L693.422 71.5H699.577L702.433 125.767C702.004 125.844 701.495 125.931 700.947 126.019C699.378 126.269 697.607 126.5 696.485 126.5C695.364 126.5 693.593 126.269 692.023 126.019C691.476 125.931 690.966 125.844 690.538 125.767Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.606166,
    d: "M692.576 71.1876L693.638 45.5H699.362L700.424 71.1876C700.431 71.358 700.295 71.5 700.124 71.5H692.876C692.705 71.5 692.569 71.358 692.576 71.1876Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.606166,
    d: "M692.615 45.1816L695.302 1.5H697.699L700.385 45.1816C700.396 45.3542 700.259 45.5 700.086 45.5H692.914C692.741 45.5 692.604 45.3542 692.615 45.1816Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.520229,
    d: "M709.5 132C709.5 128.942 709.102 127.278 708.589 126.392C708.352 125.982 708.098 125.753 707.839 125.608C707.569 125.456 707.212 125.351 706.715 125.315C705.65 125.237 704.313 125.481 702.494 125.814C700.758 126.132 698.703 126.5 696.5 126.5C694.297 126.5 692.242 126.132 690.506 125.814C688.687 125.481 687.35 125.237 686.285 125.315C685.788 125.351 685.431 125.456 685.161 125.608C684.902 125.753 684.648 125.982 684.411 126.392C683.898 127.278 683.5 128.942 683.5 132C683.5 133.319 684.516 134.919 686.915 136.277C689.253 137.602 692.615 138.5 696.5 138.5C700.385 138.5 703.747 137.602 706.085 136.277C708.484 134.919 709.5 133.319 709.5 132Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M772.5 539.5H829.5V781.5H772.5V539.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M747.5 539.5H772.5V781.5H747.5V539.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771 541H755H749V547.303V649H755V547.303H771V541Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M828 541H781H774V547.303V780H781V547.303H828V541Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1027 734.5H1054.5V781.5H981.5V714.5H1025.5V733V734.5H1027Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M819.5 714.5H981.5V781.5H819.5V714.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M980 716H827H821V722V780H827V722H980V716Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021 716H990H983V722V780H990V722H1021V736V739H1024H1053V736H1024V722V716H1021Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M880.5 714.5V700.5H891.5V714.5H880.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M891.5 714.5V700.5H919.5V714.5H891.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1054.5 714.5H1146.5V781.5H1054.5V714.5Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145 716H1062H1056V722V780H1062V722H1145V716Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1146.5 714.5H1168.5V781.5H1146.5V714.5Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1054.5 714.5V703.5H1111.5V714.5H1054.5Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1111.5 714.5V703.5H1135.5V714.5H1111.5Z",
    fill: "#2CA0AF",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1035.5 781.5V760.5H1076.5V781.5H1035.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M1076.5 781.5V760.5H1111.5V781.5H1076.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M612.5 650.5H683.5V781.5H612.5V650.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M752.5 650.5H779.5V781.5H752.5V650.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M683.5 650.5H752.5V781.5H683.5V650.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M718.5 635.5H747.5V650.5H718.5V635.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566476,
    d: "M628.5 635.5H718.5V650.5H628.5V635.5Z",
    fill: "#C5DBE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620 652H614V655V780H620V655H682V652H620Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685 652H691H751V663H691V780H685V663V652ZM778 652H754V663H778V652Z",
    fill: "#C5DBE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170,
    height: 783,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineSolid);
export default __webpack_public_path__ + "static/media/skyline-solid.fa676432e083b0f17883bf6beecee4c0.svg";
export { ForwardRef as ReactComponent };